/* eslint-disable @atlaskit/design-system/prefer-primitives */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { Popup } from '@atlaskit/editor-common/ui';
import { container } from './styles';
export default function FloatingToolbar(_ref) {
  var children = _ref.children,
    target = _ref.target,
    offset = _ref.offset,
    fitWidth = _ref.fitWidth,
    _ref$fitHeight = _ref.fitHeight,
    fitHeight = _ref$fitHeight === void 0 ? 40 : _ref$fitHeight,
    onPositionCalculated = _ref.onPositionCalculated,
    popupsMountPoint = _ref.popupsMountPoint,
    popupsBoundariesElement = _ref.popupsBoundariesElement,
    className = _ref.className,
    absoluteOffset = _ref.absoluteOffset,
    alignX = _ref.alignX,
    alignY = _ref.alignY,
    zIndex = _ref.zIndex;
  if (!target) {
    return null;
  }
  return jsx(Popup, {
    absoluteOffset: absoluteOffset,
    alignX: alignX,
    alignY: alignY,
    target: target,
    zIndex: zIndex,
    mountTo: popupsMountPoint,
    boundariesElement: popupsBoundariesElement,
    offset: offset,
    fitWidth: fitWidth,
    fitHeight: fitHeight,
    onPositionCalculated: onPositionCalculated
  }, jsx("div", {
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    css: container(fitHeight),
    "data-testid": "popup-container"
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: className
  }, children));
}